/**
 * Owner portal → Settings. The implementation is shared with the staff
 * Account & profile page; only the Payouts tab and the header copy differ.
 */
import { AccountSettingsPanel } from "@/components/settings/AccountSettingsPanel";

export function AdminOwnerSettings() {
  return <AccountSettingsPanel audience="owner" />;
}

export default AdminOwnerSettings;
